import { Link, useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useAppState, actions } from "./context/AppContext";
import { signOut } from "firebase/auth";
import { auth } from "./services/firebase";
import { usePractice } from "./usePractice";
import { useIsPracticeAdmin } from "./useIsPracticeAdmin";
import { getBrand } from "./utils/brand";

function Header() {
  const { state, dispatch } = useAppState();
  const navigate = useNavigate();
  const { slug } = useParams();
  const queryClient = useQueryClient();
  const { practice } = usePractice();
  const { isAdmin } = useIsPracticeAdmin();
  const brand = getBrand(practice?.fields?.brand);
  const practices = state.user?.practices || [];
  const hasMultiplePractices = practices.length > 1;

  function handleSignOut() {
    signOut(auth)
      .catch((error) => {
        console.error("Sign out error", error);
      })
      .finally(() => {
        queryClient.clear();
        dispatch(actions.setUser(null));
        navigate("/");
      });
  }

  function handlePracticeChange(e) {
    const newSlug = e.target.value;
    if (newSlug && newSlug !== slug) {
      navigate(`/${newSlug}`);
    }
  }

  return (
    <div className="header">
      <Link to={state.isProtectedRoute ? "/" : brand.url}>
        <img src={brand.src} alt={brand.alt} className={brand.className} />
      </Link>

      {state.user && (
        <div className="menu-container">
          {practice?.fields?.practiceName &&
            (hasMultiplePractices ? (
              <select
                className="practice-switcher"
                value={slug || ""}
                onChange={handlePracticeChange}
                aria-label="Switch practice"
              >
                {practices.map((p) => (
                  <option key={p.slug} value={p.slug}>
                    {p.name}
                  </option>
                ))}
              </select>
            ) : (
              <div className="base-bold" data-cy="practice-name">
                {practice.fields?.practiceName}
              </div>
            ))}
          {isAdmin && slug && state.isProtectedRoute && (
            <div>
              <Link className="link" to={`/${slug}/admin`} data-cy="admin-link">
                Settings
              </Link>
            </div>
          )}
          <div>{state.user.email}</div>
          <div>
            <span
              className="link"
              data-cy="user-sign-out"
              onClick={handleSignOut}
            >
              Sign Out
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
